// Customizable Area Start
import React, { createContext, Component, ReactNode } from "react";
const configJSON = require("./config.js");

export interface CustomContextProps {
  unreadCount: number;
  selectedChatUID: string;
  isLoggedIn: boolean;
  setUnreadCount: (count: number) => void;
  setSelectedChatUID: (userUID: string) => void;
  setIsLoggedIn: (status: boolean) => void;
}

export const CustomContext = createContext<CustomContextProps>({
  unreadCount: 0,
  selectedChatUID: "",
  isLoggedIn: false,
  setUnreadCount: () => {},
  setSelectedChatUID: () => {},
  setIsLoggedIn: () => {},
});

interface State {
  unreadCount: number;
  selectedChatUID: string;
  isLoggedIn: boolean;
}

interface Props {
  children: ReactNode;
}

export class CustomContextProvider extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      unreadCount: 0,
      selectedChatUID: "",
      isLoggedIn: !!localStorage.getItem(configJSON.TOKEN),
    };
  }

  setUnreadCount = (count: number) => {
    this.setState({ unreadCount: count });
  };

  setSelectedChatUID = (userUID: string) => {
    this.setState({ selectedChatUID: userUID });
  };

  setIsLoggedIn = (status: boolean) => {
    this.setState({ isLoggedIn: status });
  };

  render() {
    const { selectedChatUID, unreadCount, isLoggedIn } = this.state;
    return (
      <CustomContext.Provider
        value={{
          unreadCount,
          selectedChatUID,
          isLoggedIn,
          setUnreadCount: this.setUnreadCount,
          setSelectedChatUID: this.setSelectedChatUID,
          setIsLoggedIn: this.setIsLoggedIn,
        }}
      >
        {this.props.children}
      </CustomContext.Provider>
    );
  }
}

export const useAuth = () => React.useContext(CustomContext);
// Customizable Area End